class EventsArticleHero extends HTMLElement {
  constructor() {
    super();
    this.updateActiveOnScroll = this.updateActiveOnScroll.bind(this);
    this.updateNavWrapPosition = this.updateNavWrapPosition.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.isScrollingToAnchor = false;
    this.links = [];
  }

  connectedCallback() {
    const nav = document.querySelector(".events-article-hero__nav");
    if (!nav) return;

    this.navWrap = document.querySelector(".events-article-hero__nav-wrap");

    const linkableElements = document.querySelectorAll("[data-internal-link]");
    this.links = [];
    this.linkableElements = linkableElements;

    function debounce(fn, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), delay);
      };
    }

    const handleClick = debounce((link, id) => {
      this.isScrollingToAnchor = true;

      if (!link.classList.contains("button")) {
        this.links.forEach((l) => l.classList.remove("active"));
        link.classList.add("active");
      }

      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });

        setTimeout(() => {
          this.isScrollingToAnchor = false;
        }, 800);
      }
    }, 200);

    let hasCta = false;

    linkableElements.forEach((el, index) => {
      const text = el.getAttribute("data-internal-link");
      const id = el.id;
      const isCta = el.hasAttribute("data-internal-link-cta");

      if (id && text) {
        const link = document.createElement("a");
        link.href = `#${id}`;
        link.textContent = text;
        link.dataset.targetId = id;

        if (isCta) {
          link.classList.add("button", "button--primary");
          hasCta = true;
        } else {
          link.classList.add("events-article-hero__nav-link");
          if (index === 0) link.classList.add("active");
          this.links.push(link);
        }

        link.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.isScrollingToAnchor) return;
          handleClick(link, id);
        });

        nav.appendChild(link);
      }
    });

    if (!hasCta && !nav.querySelector(".button")) {
      const customLiquidSection = document.querySelector(
        'section[id*="custom_liquid"] [class*="klaviyo-form-"]'
      );
      if (customLiquidSection) {
        const target = customLiquidSection.closest("section");
        if (!target.querySelector("[id]")) {
          target.id = target.id || "event-sign-up";
        }
        const targetId = target.id;

        const rsvpBtn = document.createElement("a");
        rsvpBtn.href = `#${targetId}`;
        rsvpBtn.textContent = this.getAttribute("data-cta-text") || "RSVP";
        rsvpBtn.classList.add("button", "button--primary");

        rsvpBtn.addEventListener("click", (e) => {
          e.preventDefault();
          if (this.isScrollingToAnchor) return;
          handleClick(rsvpBtn, targetId);
        });

        nav.appendChild(rsvpBtn);
      }
    }

    nav.style.opacity = "1";

    this.updateActiveOnScroll();
    this.updateNavWrapPosition();
    window.addEventListener("scroll", this.onScroll, { passive: true });
    window.addEventListener("resize", this.updateNavWrapPosition);
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("resize", this.updateNavWrapPosition);
  }

  onScroll() {
    this.updateActiveOnScroll();
    this.updateNavWrapPosition();
  }

  updateActiveOnScroll() {
    if (this.isScrollingToAnchor) return;

    let currentSection = null;

    this.linkableElements?.forEach((section) => {
      const top = section.getBoundingClientRect().top;
      if (top <= 100) {
        currentSection = section;
      }
    });

    if (currentSection) {
      const id = currentSection.id;
      this.links.forEach((link) => {
        link.classList.toggle("active", link.dataset.targetId === id);
      });
    }
  }

  updateNavWrapPosition() {
    if (!this.navWrap) return;
    if (window.innerWidth >= 1024 && window.scrollY > 30) {
      this.navWrap.style.top = "104px";
    } else {
      this.navWrap.style.top = "";
    }
  }
}

customElements.define("events-article-hero", EventsArticleHero);
